const additionalActions = [
  
  '*', // full access

  'abTestsList',

  'analyticsList',

  'bannersList',
  'bannersCreate',
  'bannersUpdate',
  'bannersDelete',

  'bannerBlocksList',
  'bannerBlocksCreate',
  'bannerBlocksUpdate',
  'bannerBlocksDelete',

  'brandContext',
  'brandedUrlShortenerConfigure',

  'catalogTriggersList',
  'catalogTriggersCreate',
  'catalogTriggersUpdate',
  'catalogTriggersDelete',

  'continuousCampaignsList',
  'continuousCampaignsUpdate',

  'continuousWorkflowsList',
  'continuousWorkflowsCreate',
  'continuousWorkflowsUpdate',
  'continuousWorkflowsDelete',

  'couponsList',
  'couponsCreate',
  'couponsUpdate',
  'couponsDelete',

  'createContent',
  'generatedContentList',

  'emailsList',
  'emailsCreate',
  'emailsUpdate',
  'emailsDelete',

  'eventsList',

  'facebookAdsList',
  'facebookAdsCreate',
  'facebookAdsUpdate',
  'facebookAdsDelete',

  'facebookProductSetsList',
  'facebookProductSetsCreate',
  'facebookProductSetsUpdate',
  'facebookProductSetsDelete',

  'googleAdsList',
  'googleAdsCreate',
  'googleAdsUpdate',
  'googleAdsDelete',

  'imagesList',

  'influencersList',

  'layoutsList',
  'layoutsCreate',
  'layoutsUpdate',
  'layoutsDelete',

  'loyaltyList',
  'loyaltyCreate',
  'loyaltyUpdate',
  'loyaltyDelete',

  'oneOffCampaignsList',
  'oneOffCampaignsCreate',
  'oneOffCampaignsUpdate',
  'oneOffCampaignsDelete',

  'oneOffWorkflowsList',
  'oneOffWorkflowsCreate',
  'oneOffWorkflowsUpdate',
  'oneOffWorkflowsDelete',

  'pipelinesList',
  'pipelinesCreate',
  'pipelinesUpdate',
  'pipelinesDelete',

  'postPurchaseBannersAttach',

  'productBlocksList',
  'productBlocksCreate',
  'productBlocksUpdate',
  'productBlocksDelete',

  'productFeedsList',
  'productFeedsCreate',
  'productFeedsUpdate',
  'productFeedsDelete',

  'productsList',
  'productTrendsList',

  'profilesList',

  'pushNotificationsList',
  'pushNotificationsCreate',
  'pushNotificationsUpdate',
  'pushNotificationsDelete',

  'reportsList',
  'reportsCreate',
  'reportsUpdate',
  'reportsDelete',

  'segmentsList',
  'segmentsCreate',
  'segmentsUpdate',
  'segmentsDelete',

  'surveysList',
  'surveysCreate',
  'surveysUpdate',
  'surveysDelete',

  'textMessagesList',
  'textMessagesCreate',
  'textMessagesUpdate',
  'textMessagesDelete',

  'triggeredCampaignsUpdate',
  'triggeredWorkflowsList',
  'triggeredWorkflowsCreate',
  'triggeredWorkflowsUpdate',
  'triggeredWorkflowsDelete',

  'viberMessagesList',
  'viberMessagesCreate',
  'viberMessagesUpdate',
  'viberMessagesDelete',

  'whatsappMessagesList',
  'whatsappMessagesCreate',
  'whatsappMessagesUpdate',
  'whatsappMessagesDelete',
];

export default additionalActions;
